module.exports = "<div class=toolbar> <add-post-button></add-post-button> <filter-posts current-view=currentView filters=filters embed-only=false></filter-posts> <filter-by-survey></filter-by-survey> <div class=\"button-group hide-until-medium\" embed-only=true> <post-share filters=filters button=true></post-share> </div> <div class=button-group embed-only=false> <post-share filters=filters button=true></post-share> </div> <div class=progress-bar ng-show=isLoading.state> <span> Loading... </span> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./app/main/posts/views/post-toolbar.html
// module id = 764
// module chunks = 0